module.exports = __webpack_public_path__ + "img/chatbot-cat.7167e212.png";